import { render, staticRenderFns } from "./SalesNotifications.vue?vue&type=template&id=05bfea23&scoped=true&"
import script from "./SalesNotifications.vue?vue&type=script&lang=js&"
export * from "./SalesNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SalesNotifications.vue?vue&type=style&index=0&id=05bfea23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfea23",
  null
  
)

export default component.exports